/**
 * Created by vladislav on 9/6/2022
 */

const LabSysTech = function () {
    PortalBase.call(this, connector.LABSYSTECH);
};

LabSysTech.prototype = Object.create(PortalBase.prototype);
LabSysTech.prototype.constructor = LabSysTech;

LabSysTech.prototype.getLocalStoragePrefix = function () {
    return "_labsystech";
};
